import * as yup from 'yup';
import {
  EMAIL,
  first_name,
  last_name,
  PHONE_NUMBER,
} from '../../../../utils/validation';

export const userFormSchema = yup.object({
  lastName: yup.string().required(last_name.required),
  firstName: yup.string().required(first_name.required),
  email: yup.string().email(EMAIL.type).required(EMAIL.required),
  phoneNumber: yup.number().typeError(PHONE_NUMBER.type),
});

export const userInitForm = (user?: IUser | null) => {
  return {
    userUpdated: false,
    lastName: user?.lastName ?? '',
    firstName: user?.firstName ?? '',
    email: user?.email ?? '',
    phoneNumber: user?.phoneNumber ?? '',
    enableNewsLetter: user?.enableNewsLetter,
  };
};
